import { Button, ComboBox, Dialog, DialogBody, DialogContent, DialogFooter, Label } from '@civilgrid/ui/components';
import type { AssigneeOption } from './useBulkReassign';

export type ReassignDialogProps = {
  open: boolean;
  onClose: () => void;
  assigneeId: string;
  onAssigneeIdChange: (value: string) => void;
  assigneeOptions: AssigneeOption[];
  onSubmit: () => void;
  isPending: boolean;
};

export function ReassignDialog({
  open,
  onClose,
  assigneeId,
  onAssigneeIdChange,
  assigneeOptions,
  onSubmit,
  isPending,
}: ReassignDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="civilsearch-bulk-reassign-dialog" title="Reassign" preventDismiss className="w-75">
        <DialogBody className="flex flex-col gap-2 w-full">
          <Label>Assignee</Label>
          <ComboBox
            options={assigneeOptions}
            value={assigneeId}
            onValueChange={onAssigneeIdChange}
            placeholder="Select a civil searcher"
            emptyText="No civil searcher found."
            searchPlaceholder="Search civil searchers..."
            triggerClassName="w-full"
          />
        </DialogBody>
        <DialogFooter>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={onSubmit} disabled={isPending || !assigneeId}>
            {isPending ? 'Updating…' : 'Update'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
